module.exports = __webpack_public_path__ + "static/media/Progressive.43378473.png";